// Sanal "Tüm Çalışanlar" grubu. Backend karşılığı:
// Flexbee.Api.Models.UserGroup.AllEmployeesGroupId — iki taraf birlikte değişir.
//
// İzin politikası / çalışma planı / onay akışı ekranlarında bu grup SEÇİLEMEZ:
// o modüllerde varsayılan zaten atamasız herkese uygulanıyor, "tüm çalışanlara
// ata" ise varsayılanı kişi kişi dondurup değiştirilemez hâle getiriyordu.
export const ALL_EMPLOYEES_GROUP_ID = '00000000-0000-0000-0000-000000000001';
